import { SORT_TYPE } from '@app/constants/commonConstants';
import { generateSchemaForCSR } from './utils';

export const MAXLENGTH = 40;
export const SAVED_LIST_FIELDS = {
  NAME: 'folName',
  ITEM_PART_NUMBER: 'itemPartNumber',
  CREATED_BY: 'createdBy',
  DATE_VALUE: 'dateValue'
};

export const SAVED_LIST_COLUMN_IDS = {
  NAME: 'name',
  ACTIONS: 'actions',
  QUANTITY: 'quantity',
  CREATED_BY: 'createdBy',
  UPDATED_DATE: 'updated',
  EXPIRES: 'expires',
  LIST_TYPE: 'type'
};

export const getSavedListTableSchema = (
  isInstantAccess,
  isCSPCustomer,
  isCatCSR = false
) => {
  let widthCreatedBy = isInstantAccess && !isCSPCustomer ? '289px' : '258px';

  if (isCatCSR) {
    widthCreatedBy = '440px';
  }

  const initialSchema = [
    {
      id: SAVED_LIST_COLUMN_IDS.NAME,
      label: 'sortBy_2',
      behavior: 'sortable',
      sortType: SORT_TYPE.ALPHANUMERIC,
      width: isCatCSR ? '312px' : '192px'
    },
    { id: SAVED_LIST_COLUMN_IDS.ACTIONS, width: '50px' },
    {
      id: SAVED_LIST_COLUMN_IDS.QUANTITY,
      label: 'REQUISITIONLIST_QUANTITY',
      width: '120px',
      behavior: 'sortable',
      sortType: SORT_TYPE.NUMERIC
    },
    {
      id: SAVED_LIST_COLUMN_IDS.CREATED_BY,
      label: 'CREATED_BY',
      behavior: 'sortable',
      sortType: SORT_TYPE.ALPHANUMERIC,
      width: widthCreatedBy
    },
    {
      id: SAVED_LIST_COLUMN_IDS.UPDATED_DATE,
      label: isCatCSR ? 'UPDATED' : 'REQUISITIONLIST_UPDATED',
      width: isInstantAccess && !isCSPCustomer ? '200px' : '160px',
      behavior: 'sortable',
      sortType: SORT_TYPE.DATE
    },
    {
      id: SAVED_LIST_COLUMN_IDS.LIST_TYPE,
      label: 'REQUISITIONLIST_TYPE',
      width: '120px',
      align: 'center'
    }
  ];

  if (isCatCSR) {
    return generateSchemaForCSR(initialSchema);
  }

  return initialSchema;
};

export const EXTENSION_FILES = ['csv', 'xls', 'xlsx'];
export const FILE_SIZE_LIMIT = 75;
export const FIRST_PAGE = 1;
export const LIST_TYPES = { PRIVATE: 'private', SHARED: 'shared' };
export const PAGE_LIMIT = 12;
export const PAGE_SIZE_OPTIONS = [12, 24, 48, 96];
export const DATE_FORMAT = 'MM/dd/yy';
export const CREATE_LIST_MODAL_FIELDS = {
  LIST_NAME: 'folName',
  LIST_TYPE: 'listType',
  FILE_NAME: 'fileName'
};
export const SAVED_LIST_MANAGE_VIEW_FIELDS = {
  SHOW_MY_FAVS: 'savedList_showOnlyMyFavorites',
  SHOW_MY_LISTS: 'savedList_showOnlyMyList'
};
export const SIZE = { SM: 'sm' };
export const VARIANT = { PRIMARY: 'primary' };

export const SHOW = 'show';
export const TOAST_VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
  NONE: 'none'
};

export const KEBAB_OPTIONS = {
  ADD_TO_CART: 'addtocart',
  MARK_FAVORITE: 'markfavorite',
  DUPLICATE_LIST: 'duplicatelist',
  DELETE_LIST: 'deletelist',
  SHARED_LIST: 'sharedlist'
};
export const INITIAL_FILE_UPLOAD_DATA = [
  {
    fileId: '',
    file: '',
    status: '',
    statusText: '',
    fileObject: {}
  }
];

export const DFL = 'DFL';
export const FOLSTATUS_Y = 'Y';

export const MODAL_ACTIONS = {
  ADD_TO_CART: 'addtocart',
  DELETE: 'delete',
  SHARE: 'share',
  CANCEL_SHARE: 'cancelShare'
};

export const SAVED_LIST = 'savedList';

export const SAVED_LIST_MANAGE_VIEW_SCHEMA = [
  {
    id: 'showOnlyMyList',
    isDefault: true
  },
  {
    id: 'showOnlyMyFavorites',
    isDefault: false
  }
];
